import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

/**
 * Global footer with links to legal pages and contact.
 * Used on Landing and authenticated app pages.
 */
export default function Footer({ variant = "default" }) {
    const isDark = variant === "dark";
    return (
        <footer
            className={`py-10 mt-16 border-t ${isDark ? "border-white/10 bg-ink text-white/70" : "border-rule"}`}
            data-testid="global-footer"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs font-mono text-muted2">
                <div className="flex items-center gap-2">
                    <Zap size={12} className="text-orange" />
                    <span>Profawz — © {new Date().getFullYear()}</span>
                </div>
                <div className="flex flex-wrap items-center gap-4 justify-center">
                    <Link to="/mentions-legales" className="hover:text-ink transition-colors" data-testid="footer-mentions-link">
                        Mentions légales
                    </Link>
                    <Link to="/cgv" className="hover:text-ink transition-colors" data-testid="footer-cgv-link">
                        CGV
                    </Link>
                    <Link to="/cgu" className="hover:text-ink transition-colors" data-testid="footer-cgu-link">
                        CGU
                    </Link>
                    <Link to="/confidentialite" className="hover:text-ink transition-colors" data-testid="footer-confidentialite-link">
                        Confidentialité
                    </Link>
                    <Link to="/cookies" className="hover:text-ink transition-colors" data-testid="footer-cookies-link">
                        Cookies
                    </Link>
                    <Link to="/contact" className="hover:text-ink transition-colors" data-testid="footer-contact-link">
                        Contact
                    </Link>
                    <a href="mailto:contact@profawz.fr" className="hover:text-ink transition-colors">
                        contact@profawz.fr
                    </a>
                </div>
            </div>
        </footer>
    );
}
